'use strict';

angular.module('amexReconciliationApp')
  .component('additionalData', {
    templateUrl: 'scripts/views/components/additional-data.html',
    controllerAs: 'additionalDataController',
    bindings: {
      additionalTransactionData: '='
    },
    controller: function (TransactionSearchModel,
                          ActiveTransactionModel,
                          LockStatusService,
                          AdobeAnalyticsService,
                          AdditionalTransactionDataRepository,
                          TransactionsModel,
                          SiteConfigModel) {
      var self = this;

      self.saveSuccessful = false;
      self.saveUnsuccessful = false;
      self.receivedStatusList = ['EMPTY','FULLY_RECEIVED', 'PARTIALLY_RECEIVED', 'NOT_RECEIVED'];
      self.activeTransaction = ActiveTransactionModel.activeTransaction();
      self.showReceivedFields = SiteConfigModel.showReceivedFields;
      self.validationErrors = null;

      self.userDefinedFields = _.get(SiteConfigModel.siteConfig(), 'userDefinedFields', []);

      self.$onInit = function() {
        self.cardmemberComments = self.additionalTransactionData.cardmemberComments || '';
        self.managerComments = self.additionalTransactionData.managerComments || '';
        self.receivedStatus = self.additionalTransactionData.receivedStatus || 'EMPTY';
        self.receiverName = self.additionalTransactionData.receiverName || '';
        self.userDefinedValues = _.cloneDeep(self.additionalTransactionData.userDefinedValues) || [];
      };

      self.displaySaveSuccessful = function() {
        return self.saveSuccessful && formIsPristine();
      };

      self.displaySaveUnsuccessful = function () {
        return self.saveUnsuccessful && formIsPristine();
      };

      self.isLocked = function () {
        return self.isFieldTypeLocked('comments') && self.isFieldTypeLocked('receiver') && self.isFieldTypeLocked('userDefinedFields');
      };

      self.isFieldTypeLocked = function(fieldType) {
        var isDisabledForPartialLock = _.get(SiteConfigModel.siteConfig().partialLockOptions, fieldType+'Locked');
        if (LockStatusService.isPartiallyLocked(self.activeTransaction) && isDisabledForPartialLock) {
          return true;
        }

        return LockStatusService.isLocked(self.activeTransaction);
      };
      
      self.cancelDisabled = formIsPristine;

      self.saveDisabled = function() {
        return formIsPristine() || formIsInvalid();
      };

      function formIsPristine() {
        return _.get(self, 'form.$pristine', true);
      }

      function formIsInvalid() {
        return _.get(self, 'form.$invalid', true);
      }

      self.resetValues = function () {
        self.$onInit();
        self.form.$setPristine();
      };

      self.dropDownValuesForField = function (field) {
        var values = [];

        if (field.dropDownValues !== null) {
          values = _.split(field.dropDownValues, '^');
        }

        return values;
      };

      self.updateAdditionalData = function () {
        var newAdditionalTransactionData = {
          id: self.activeTransaction.id,
          receivedStatus: self.receivedStatus,
          receiverName: self.receiverName,
          userDefinedValues: self.userDefinedValues
        };

        if (self.canEditCardmemberComments()) {
          newAdditionalTransactionData.cardmemberComments = self.cardmemberComments;
        }

        if (self.canEditManagerComments()) {
          newAdditionalTransactionData.managerComments = self.managerComments;
        }

        AdditionalTransactionDataRepository.updateAdditionalData(newAdditionalTransactionData)
          .then(function () {
            saveSuccessful();
            TransactionsModel.refreshTransactions([self.activeTransaction.id]);
            _.assign(self.additionalTransactionData, newAdditionalTransactionData);
          })
          .catch(function (response) {
            validationErrorsOnSave(response);
            TransactionsModel.refreshTransactions([self.activeTransaction.id]);
          })
          .finally(function () {
            self.form.$setPristine();
          });
      };

      function saveSuccessful() {
        self.saveSuccessful = true;
        self.saveUnsuccessful = false;
        self.validationErrors = null;
      }

      function validationErrorsOnSave(response) {
        self.saveSuccessful = false;
        self.saveUnsuccessful = true;
        if(response.data) {
          self.validationErrors = response.data.validationErrors;
        }
      }

      self.canEditCardmemberComments = function canEditCardmemberComments() {
        return TransactionSearchModel.isCardMember();
      };

      self.canEditManagerComments = function canEditManagerComments() {
        return TransactionSearchModel.isBcaManager() ||
          TransactionSearchModel.isCardManager() ||
          TransactionSearchModel.isAccountingManager();
      };

      self.trackAnalytics = function trackAnalytics() {
        var status = 'Empty';
        switch (self.receivedStatus) {
          case 'EMPTY':
            status = 'Empty';
            break;
          case 'FULLY_RECEIVED':
            status = 'Fully Received';
            break;
          case 'PARTIALLY_RECEIVED':
            status = 'Partially Received';
            break;
          case 'NOT_RECEIVED':
            status = 'Not Received';
            break;
        }

        AdobeAnalyticsService.eventTrack('click', { 'eventAsset': 'Received Status - '+status, 'tab':'transactionTab'});

      };

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/additionalData.js
// module id = 428
// module chunks = 0